import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar el vacío",
    opening: localizedGenderNode(
      [
      "Hoy no intento llenar el vacío.",
      "Solo noto: esta aquí."
    ],
      [
      "Hoy no intento llenar el vacío.",
      "Solo noto: esta aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cuando es más fuerte el vacío?",
      "Como suena el vacío en mi mente?",
      "Que siento en mi cuerpo?"
    ],
      [
      "Cuando es más fuerte el vacío?",
      "Como suena el vacío en mi mente?",
      "Que siento en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El vacío es una experiencia, no soy yo."
    ],
      [
      "El vacío es una experiencia, no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion + \"Estoy aquí con el vacío\".",
      "una respiracion + \"Estoy aquí con el vacío\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer momento",
    opening: localizedGenderNode(
      [
      "Hoy noto el momento en que empieza.",
      "Solo noto."
    ],
      [
      "Hoy noto el momento en que empieza.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ],
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pasa justo antes de que suba el vacío?",
      "Donde me encuentra en el día?",
      "Que intento evitar?"
    ],
      [
      "Que pasa justo antes de que suba el vacío?",
      "Donde me encuentra en el día?",
      "Que intento evitar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "En el primer momento tengo un poco de espacio."
    ],
      [
      "En el primer momento tengo un poco de espacio."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion cuando empieza.",
      "una respiracion cuando empieza."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Señales del cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi cuerpo antes del pensamiento.",
      "Me quedo conmigo."
    ],
      [
      "Hoy escucho mi cuerpo antes del pensamiento.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ],
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Donde siente mi cuerpo el vacío?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ],
      [
      "Donde siente mi cuerpo el vacío?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi cuerpo intenta cuidarme."
    ],
      [
      "Mi cuerpo intenta cuidarme."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho y una respiracion.",
      "una mano en el pecho y una respiracion."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Historia vs. hecho",
    opening: localizedGenderNode(
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia."
    ],
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cual es el hecho simple aquí?",
      "Que historia salto?",
      "Que posibilidad más suave tambien podria ser cierta?"
    ],
      [
      "Cual es el hecho simple aquí?",
      "Que historia salto?",
      "Que posibilidad más suave tambien podria ser cierta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una historia no soy yo."
    ],
      [
      "Una historia no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna - \"Esto es una historia que aparece\".",
      "una frase interna - \"Esto es una historia que aparece\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Lo que se drena",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que se me drena.",
      "No para culpar."
    ],
      [
      "Hoy noto lo que se me drena.",
      "No para culpar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento mis pies.",
      "Una respiracion."
    ],
      [
      "Siento mis pies.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que suele drenarme?",
      "Que sigo haciendo incluso sin energía?",
      "Que me falta para sentirme 10% más presente?"
    ],
      [
      "Que suele drenarme?",
      "Que sigo haciendo incluso sin energía?",
      "Que me falta para sentirme 10% más presente?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar lo que se drena ya es un comienzo."
    ],
      [
      "Notar lo que se drena ya es un comienzo."
    ]
    ),
    action: localizedGenderNode(
      "escribir una cosa que me drena.",
      "escribir una cosa que me drena."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Voces silenciosas",
    opening: localizedGenderNode(
      [
      "Hoy noto las voces silenciosas debajo del vacío.",
      "No empujo."
    ],
      [
      "Hoy noto las voces silenciosas debajo del vacío.",
      "No empujo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Ablando un poco los hombros.",
      "Una respiracion."
    ],
      [
      "Ablando un poco los hombros.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que frase silenciosa se repite en mi?",
      "Que pide esa frase?",
      "Que dice mi voz suave?"
    ],
      [
      "Que frase silenciosa se repite en mi?",
      "Que pide esa frase?",
      "Que dice mi voz suave?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz silenciosa puede ser un ancla."
    ],
      [
      "Una voz silenciosa puede ser un ancla."
    ]
    ),
    action: localizedGenderNode(
      "elegir una frase silenciosa.",
      "elegir una frase silenciosa."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Una pequeña necesidad",
    opening: localizedGenderNode(
      [
      "Hoy toco la necesidad debajo del vacío.",
      "No resuelvo."
    ],
      [
      "Hoy toco la necesidad debajo del vacío.",
      "No resuelvo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pongo una mano en el pecho.",
      "Una respiracion."
    ],
      [
      "Pongo una mano en el pecho.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que necesito para sentirme un poco más vivo/a?",
      "Que en mi pide calor o cercanía?",
      "Como se siente cuando me doy un momento?"
    ],
      [
      "Que necesito para sentirme un poco más vivo/a?",
      "Que en mi pide calor o cercanía?",
      "Como se siente cuando me doy un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Detras del vacío hay una peticion."
    ],
      [
      "Detras del vacío hay una peticion."
    ]
    ),
    action: localizedGenderNode(
      "escribir una peticion para mi.",
      "escribir una peticion para mi."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Una pequeña conexion",
    opening: localizedGenderNode(
      [
      "Hoy busco una pequeña conexion dentro de mi.",
      "No grande, solo posible."
    ],
      [
      "Hoy busco una pequeña conexion dentro de mi.",
      "No grande, solo posible."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento la espalda apoyada.",
      "Una respiracion."
    ],
      [
      "Siento la espalda apoyada.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que me da sensación de conexion ahora?",
      "Que palabra me calma?",
      "Que puedo darme por un momento?"
    ],
      [
      "Que me da sensación de conexion ahora?",
      "Que palabra me calma?",
      "Que puedo darme por un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una pequeña conexion sigue siendo conexion."
    ],
      [
      "Una pequeña conexion sigue siendo conexion."
    ]
    ),
    action: localizedGenderNode(
      "una palabra tranquila en mi corazon.",
      "una palabra tranquila en mi corazon."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Compasion hacia mi",
    opening: localizedGenderNode(
      [
      "Hoy me hablo con suavidad.",
      "No como un juez."
    ],
      [
      "Hoy me hablo con suavidad.",
      "No como un juez."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Suavizo la mandíbula.",
      "Una respiracion."
    ],
      [
      "Suavizo la mandíbula.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Como le hablaria a un amigo aquí?",
      "Que frase suave necesito escuchar?",
      "Que puedo perdonarme?"
    ],
      [
      "Como le hablaria a un amigo aquí?",
      "Que frase suave necesito escuchar?",
      "Que puedo perdonarme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La suavidad no cancela el vacío."
    ],
      [
      "La suavidad no cancela el vacío."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mi.",
      "una frase suave para mi."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una peticion interna",
    opening: localizedGenderNode(
      [
      "Hoy me doy una peticion clara.",
      "No una exigencia, solo una peticion."
    ],
      [
      "Hoy me doy una peticion clara.",
      "No una exigencia, solo una peticion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el abdomen aflojar un poco.",
      "Una respiracion."
    ],
      [
      "Siento el abdomen aflojar un poco.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cual es mi peticion más importante ahora?",
      "Como decirla en una sola frase?",
      "Que estoy dispuesto/a a darme a cambio?"
    ],
      [
      "Cual es mi peticion más importante ahora?",
      "Como decirla en una sola frase?",
      "Que estoy dispuesto/a a darme a cambio?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una peticion puede ayudarme a moverme."
    ],
      [
      "Una peticion puede ayudarme a moverme."
    ]
    ),
    action: localizedGenderNode(
      "escribir la peticion en una frase corta.",
      "escribir la peticion en una frase corta."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un valor suave",
    opening: localizedGenderNode(
      [
      "Hoy me recuerdo un valor pequeño que me sostiene.",
      "No grande."
    ],
      [
      "Hoy me recuerdo un valor pequeño que me sostiene.",
      "No grande."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto el rostro más calmado.",
      "Una respiracion."
    ],
      [
      "Noto el rostro más calmado.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que valor pequeño me importa ahora?",
      "Como se ve ese valor en un día normal?",
      "Que pequeño paso interno lo honra?"
    ],
      [
      "Que valor pequeño me importa ahora?",
      "Como se ve ese valor en un día normal?",
      "Que pequeño paso interno lo honra?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un valor pequeño me da direccion."
    ],
      [
      "Un valor pequeño me da direccion."
    ]
    ),
    action: localizedGenderNode(
      "elegir un valor y repetirlo en mi corazon.",
      "elegir un valor y repetirlo en mi corazon."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Como estoy conmigo",
    opening: localizedGenderNode(
      [
      "Hoy observo como me trato.",
      "No juzgo."
    ],
      [
      "Hoy observo como me trato.",
      "No juzgo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me doy medio minuto de silencio.",
      "Una respiracion."
    ],
      [
      "Me doy medio minuto de silencio.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cuando me presiono a mi mismo/a?",
      "Donde puedo aflojar un poco?",
      "Como quiero hablarme en el futuro?"
    ],
      [
      "Cuando me presiono a mi mismo/a?",
      "Donde puedo aflojar un poco?",
      "Como quiero hablarme en el futuro?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Como estoy conmigo importa."
    ],
      [
      "Como estoy conmigo importa."
    ]
    ),
    action: localizedGenderNode(
      "una frase de respeto hacia mi.",
      "una frase de respeto hacia mi."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un pequeño cambio",
    opening: localizedGenderNode(
      [
      "Hoy elijo un pequeño cambio que puedo sostener.",
      "No una revolucion."
    ],
      [
      "Hoy elijo un pequeño cambio que puedo sostener.",
      "No una revolucion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el cuerpo estable por un momento.",
      "Una respiracion."
    ],
      [
      "Siento el cuerpo estable por un momento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pequeño cambio podria ayudarme hoy?",
      "Como se veria en la practica?",
      "Que estoy dispuesto/a a intentar una vez?"
    ],
      [
      "Que pequeño cambio podria ayudarme hoy?",
      "Como se veria en la practica?",
      "Que estoy dispuesto/a a intentar una vez?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Lo pequeño suficiente es suficiente."
    ],
      [
      "Lo pequeño suficiente es suficiente."
    ]
    ),
    action: localizedGenderNode(
      "un paso pequeño para mi.",
      "un paso pequeño para mi."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy cierro con suavidad.",
      "Elijo una frase que me devuelve."
    ],
      [
      "Hoy cierro con suavidad.",
      "Elijo una frase que me devuelve."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el aire entrar y salir.",
      "Una respiracion."
    ],
      [
      "Siento el aire entrar y salir.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que aprendi sobre este vacío?",
      "Cual es la señal más temprana de que sube?",
      "Que frase me devuelve al momento anterior?"
    ],
      [
      "Que aprendi sobre este vacío?",
      "Cual es la señal más temprana de que sube?",
      "Que frase me devuelve al momento anterior?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Elijo presencia antes de reaccionar."
    ],
      [
      "Elijo presencia antes de reaccionar."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion y mi frase de regreso.",
      "una respiracion y mi frase de regreso."
    ),
  },
].map(buildNormalizedDay);

export const feelingOfInnerEmptinessIHaveNoEnergyForAnythingBlueprintEs = buildNormalizedPilotBlueprint({
  id: "feeling_of_inner_emptiness_i_have_no_energy_for_anything_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "feeling_of_inner_emptiness_i_have_no_energy_for_anything",
  category: "depression_emptiness_meaning",
  journeyName: {
    he: "תחושת ריק פנימי (אין לי אנרגיה לכלום)",
    en: "Feeling of inner emptiness (I have no energy for anything)",
    es: "Sensación de vacío interior (No tengo energía para nada)",
  },
  days,
});

export default feelingOfInnerEmptinessIHaveNoEnergyForAnythingBlueprintEs;
